import React, { useState, useContext, useEffect, useRef } from 'react'
import { Button, FlexView } from 'components/common'
import { Input, Select } from 'components/form'
import { useTranslation } from 'react-i18next'
import { TubularContext } from 'stores/TubularStore'
import { UserContext } from 'stores/UserStore'

const SearchCard = ({ tab }) => {
    const { t } = useTranslation()
    const { registryLogOld, registryLog } = useContext(UserContext)
    const [searchAll, setSearchAll] = useState('')
    const [searchClient, setSearchClient] = useState('')
    const [searchInitialDate, setSearchInitialDate] = useState('')
    const [searchFinallDate, setSearchFinallDate] = useState('')
    const [searchOrigin, setSearchOrigin] = useState('')
    const [searchDestination, setSearchDestination] = useState('')
    const [searchKeyAccess, setSearchKeyAccess] = useState('')
    const originalSearchIppn = useRef("")

    const [typeSearch, setTypeSearch] = useState("ippn")
    const [searchIppnValid, setSearchIppnValid] = useState("")
    const {
        getInvoiceSearchData,
        getPurchaseOrderSearchData, getSotSearchData,
        getIppnSearchData, getValidSearchData,
        getReservationSearchData,
        getSalesOrderSearchData,
        setIppnId,
        setValueData,
        setCustomersId,
        customersId, client,
        setValidId
    } = useContext(TubularContext)

    const { customer } = useContext(UserContext)
    const DEFAULT_URL = "/tlh/home"
    const DEFAULT_SEARCH = "SEARCH - "

    const getData = async (value) => {
        const type = {
            'invoice': await getInvoiceSearchData,
            'purchaseOrder': await getPurchaseOrderSearchData,
            'salesOrder': await getSalesOrderSearchData,
            'ippn': await getIppnSearchData,
            'valid': await getValidSearchData,
            'sot': await getSotSearchData,
            'reservation': await getReservationSearchData
        }
        return type[tab](value)
    }

    const searchItens = async () => {
        if (tab === "ippn") {
            setValueData(searchIppnValid)
            const dados = await getData({ type: typeSearch, value: searchIppnValid })
            setIppnId(originalSearchIppn.current)
            if (dados) {
                setValidId(dados.valid)
            }
        } else if (tab === "sot" || tab === "purchaseOrder" || tab === "salesOrder" || tab === "reservation") {
            setValueData(searchAll || searchClient || searchInitialDate || searchFinallDate)
            getData([searchAll, searchClient, searchInitialDate, searchFinallDate])
        }
        else {
            setValueData(searchAll || searchOrigin || searchDestination || searchClient || searchInitialDate || searchFinallDate || searchKeyAccess)
            getData([searchAll, searchOrigin, searchDestination, searchClient, searchInitialDate, searchFinallDate, searchKeyAccess])
        }
        registryLogOld(DEFAULT_SEARCH + " activeKey", DEFAULT_URL)
        registryLog('home', 'keypress', 'search')
    }

    const handleInputChange = (event) => {
        if (typeSearch === 'ippn') {
            checkIppn(event)
        } else {
            setSearchIppnValid(event)
        }
    }

    const checkIppn = (ippn) => {
        originalSearchIppn.current = ippn.replace('#', 'A')
        ippn = ippn.replace(/[^0-9]/g, '')
        setSearchIppnValid(ippn)
    }

    const getOptions = () => {
        const keys = Object.keys(customer)
        const customers = []
        keys.filter((item) => item !== 'id' ?
            Object.keys(customer[item]).filter((ID) =>
                ID !== 'id' ? customers.push({ value: customer[item][ID].id, label: ID }) : null
            )
            : null)
        setCustomersId(customers)
    }

    useEffect(() => {
        getOptions()
        setSearchAll('')
        setSearchClient('')
        setSearchDestination('')
        setSearchFinallDate('')
        setSearchInitialDate('')
        setSearchKeyAccess('')
        setSearchOrigin('')
        setSearchIppnValid('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab])

    return (
        <FlexView width="95%">
            <FlexView flexDirection='column' width="100%">
                {tab === "ippn" ?
                    <FlexView flexDirection='row' justifyContent="space-between" width="100%">
                        <Select label={t("tlh.option").toUpperCase()} width="100%" margin="0px 30px 0px 0px" options={[{ label: 'ippn'.toUpperCase(), value: 'ippn' }, { label: 'valId'.toUpperCase(), value: 'valId' }]} value={typeSearch} onChange={(e) => { setTypeSearch(e) }} />
                        <Input label={t(`tlh.home.tabs.${typeSearch}`).toUpperCase()} type="text" width="100%" margin="0px 0px" value={searchIppnValid} onChange={(e) => { handleInputChange(e.target.value) }} />
                    </FlexView>
                    : null}
                {tab === "sot" || tab === "reservation" || tab === "purchaseOrder" || tab === "salesOrder" ?
                    <>
                        <FlexView flexDirection='row' justifyContent="space-between" width="100%" >
                            <Input label={t(`tlh.home.tabs.${tab}`) === 'sot' ? 'Sot' : t(`tlh.home.tabs.${tab}`)} type="text" width="100%" margin="0px 30px 0px 0px" value={searchAll} onChange={(e) => { setSearchAll(e.target.value) }} />
                            <Select label={t("tlh.search.customer")} width="100%" margin="0px 0px" options={customersId} value={searchClient} onChange={(e) => { setSearchClient(e) }} />
                        </FlexView>
                        <FlexView flexDirection='row' justifyContent="space-between" width="100%">
                            <Input style={{ textTransform: 'uppercase', fontWeight: 'normal' }} label={t("tlh.search.initialDate")} max={new Date('20/05/2023')} type="date" width="100%" margin="0px 30px 0px 0px" value={searchInitialDate} onChange={(e) => { setSearchInitialDate(e.target.value) }} />
                            <Input style={{ textTransform: 'uppercase', fontWeight: 'normal' }} label={t("tlh.search.finalDate")} type="date" width="100%" margin="0px 0px" value={searchFinallDate} onChange={(e) => { setSearchFinallDate(e.target.value) }} />
                        </FlexView>
                    </>
                    : null}
                {tab === "invoice" ?
                    <>
                        <FlexView flexDirection='row' justifyContent="space-between" width="100%">
                            <Input label={t(`tlh.home.tabs.${tab}`)} type="text" width="100%" margin="0px 30px 0px 0px" value={searchAll} onChange={(e) => { setSearchAll(e.target.value) }} />
                            <Input label={t("tlh.search.origin")} type="text" width="100%" margin="0px 30px 0px 0px" value={searchOrigin} onChange={(e) => { setSearchOrigin(e.target.value) }} />
                            <Input label={t("tlh.search.destination")} type="text" width="100%" margin="0px 0px" value={searchDestination} onChange={(e) => { setSearchDestination(e.target.value) }} />
                        </FlexView>
                        <FlexView flexDirection='row' justifyContent="space-between" width="100%">
                            <Select label={t("tlh.search.customer")} width="100%" margin="0px 30px 0px 0px" options={client} value={searchClient} onChange={(e) => { setSearchClient(e) }} />
                            <Input style={{ textTransform: 'uppercase', fontWeight: 'normal' }} label={t("tlh.search.initialDate")} type="date" width="100%" margin="0px 30px 0px 0px" value={searchInitialDate} onChange={(e) => { setSearchInitialDate(e.target.value) }} />
                            <Input style={{ textTransform: 'uppercase', fontWeight: 'normal' }} label={t("tlh.search.finalDate")} type="date" width="100%" margin="0px 0px" value={searchFinallDate} onChange={(e) => { setSearchFinallDate(e.target.value) }} />
                        </FlexView>
                        <FlexView flexDirection='row' justifyContent="space-between" width="100%">
                            <Input label={t("tlh.search.keyAccess")} type="text" width="100%" margin="0px 0px" value={searchKeyAccess} onChange={(e) => { setSearchKeyAccess(e.target.value) }} />
                        </FlexView>
                    </>
                    : null}
                <FlexView flexDirection='row' justifyContent="end" width="100%">
                    <Button backgroundColor='secondary' color='white' onClick={() => searchItens()} >{t("tlh.search.search")}</Button>
                </FlexView>
            </FlexView>
        </FlexView>
    )
}

export default SearchCard
